import { BrowserRouter } from 'react-router-dom';
import Roads from './components/Roads';
import Footer from './components/Footer';
import { motion } from 'framer-motion';
import LocationProvider from './components/LocationProvider';
import '../src/sass/layout/_container.scss';
import "../src/sass/base/_base.scss"

function App() {

  return (
    <BrowserRouter>
      <motion.div 
        className="container"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
        >
        <LocationProvider>
          <Roads />
        <Footer />
        </LocationProvider>
      </motion.div>
    </BrowserRouter>
  );
}

export default App;
